<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style1', { sticky: isSticky }]">
      <div class="header-top">
        <div class="container">
          <TopHeader />
        </div>
      </div>
      <MainNavbarPages />
    </div>

    <div class="content-wrapper">
      <!-- <PageBanner pageTitle="Service Details" mainTitle="Service Details" /> -->
      <div class="service-details-wrap ptb-50">
        <div class="container">
          <div class="row">
            <div class="col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
              <SideBar />
            </div>

            <div class="col-xl-8 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
              <div class="service-desc">


                <div class="row">
                  <div class="col-md-9">
                    <h2>Dr. Claudiu Nicolaiev – Medic specialist în Diabet, Nutriție și Boli Metabolice</h2>
                    <div class="other-option md-none mt-40">
                      <a href="/#appointment" class="btn style2">
                        Solicită o programare
                      </a>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="team-card style3">
                      <div class="team-img"> <img src="../../../assets/images/team/member-6.jpg"
                          alt="Dr. Claudiu Nicolaiev – Diabet, Nutriție și Boli Metabolice" /></div>
                    </div>
                  </div>
                </div>

                <p>
                  Sunt <strong>Dr. Claudiu Nicolaiev</strong> medic specialist în Diabet, Nutriție și Boli Metabolice.
                  Am ales această specialitate din dorința de a ghida persoanele cu diabet zaharat, obezitate și alte
                  tulburări metabolice să-și controleze factorii de risc cardiovascular în cadrul unui proces medical
                  efectuat cu grijă și empatie.
                </p>


                <ul class="content-feature-list style5 list-style">
                  <li><i class="ri-check-double-line"></i>Diagnostic și management al diabetului zaharat </li>
                  <li><i class="ri-check-double-line"></i>Screeningul complicațiilor cronice ale diabetului zaharat
                  </li>
                  <li><i class="ri-check-double-line"></i>Prediabet, insulinorezistență, obezitate, dislipidemie,
                    hiperuricemie</li>
                  <li><i class="ri-check-double-line"></i>Estimarea riscului cardiovascular și măsuri de prevenție a
                    agravării factorilor de risc </li>
                  <li><i class="ri-check-double-line"></i>Consiliere nutrițională</li>
                </ul>


                <h3>Educație și formare profesională</h3>
                <p>
                  Medicina este o profesie ce necesită studiu permanent, astfel că am ca obiectiv formarea profesională
                  continuă sub semnul inovației și al abordării cardio-reno-hepato-metabolice.
                </p>

                <ul class="content-feature-list style5 list-style">
                  <li><i class="ri-check-double-line"></i>2021-2025 – Rezidențiat în Diabet, Nutriție și Boli
                    Metabolice, Clinica de Diabet, Nutriție și Boli Metabolice, Spitalul „Sf. Spiridon”, Iași</li>
                  <li><i class="ri-check-double-line"></i>2014-2020 – Facultatea de Medicină Generală, UMF „Gr. T.
                    Popa”, Iași</li>
                </ul>


                <h3>Experiență profesională</h3>
                <p>Pe parcursul rezidențiatului în Diabet, Nutriție și Boli Metabolice (2021-2025), mi-am orientat
                  atenția către:</p>

                <ul class="content-feature-list style5 list-style">
                  <li><i class="ri-check-double-line"></i>Educația terapeutică și nutrițională a persoanelor cu diabet
                    zaharat și alte tulburări metabolice</li>
                  <li><i class="ri-check-double-line"></i>Identificarea factorilor de risc, stabilirea riscului
                    cardiovascular și abordarea multidisciplinară pentru reducerea acestuia</li>
                  <li><i class="ri-check-double-line"></i>Integrarea tehnologiei în diabetul zaharat (sisteme de
                    monitorizare continuă a glucozei, sisteme de infuzie subcutanată continuă a insulinei)</li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>


    </div>
    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../../Layouts/TopHeader.vue";
import MainNavbarPages from "../../Layouts/MainNavbarPages.vue";
import SideBar from "./SideBar.vue";
// import ServiceDetails from "../../ServiceDetails/ServiceDetails.vue";
import MainFooter from "../../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "CardiologiePage",
  components: {
    TopHeader,
    SideBar,
    MainNavbarPages,
    // ServiceDetails,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;
      if (scrollPos >= 100) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    });
  },
});
</script>